import validate from "/home/g/p/vision/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@22.13.14_db0@0.3.1_drizzle-orm@0.40.1_@cl_36c99d9e58f28b1e85342a239b7eb724/node_modules/nuxt/dist/pages/runtime/validate.js";
import admin_45layout_45global from "/home/g/p/vision/middleware/admin-layout.global.ts";
import manifest_45route_45rule from "/home/g/p/vision/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.1_@types+node@22.13.14_db0@0.3.1_drizzle-orm@0.40.1_@cl_36c99d9e58f28b1e85342a239b7eb724/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  admin_45layout_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}